/**
 * @generated SignedSource<<ed0dbf6384ab6a6bcfd50bc58bb4adbd>>
 * @relayHash d39e5b031406032a7dff6b1b644540dc
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 785e4a57d525e0253c7efa9ebd6c8bf9033bc904c857b792c83dd3959efef986

import type { ConcreteRequest } from 'relay-runtime';
export type JiraProjectType = "BUSINESS" | "CUSTOMER_SERVICE" | "PRODUCT_DISCOVERY" | "SERVICE_DESK" | "SOFTWARE" | "%future added value";
export type issueViewSwitchDataFetcherQuery$variables = {
  cloudId: string;
  includeAgenticWorkItemData: boolean;
  issueKey: string;
  projectIdOrKey: string;
  skipIssueByKey: boolean;
};
export type issueViewSwitchDataFetcherQuery$data = {
  readonly jira: {
    readonly issueByKey?: {
      readonly key: string;
      readonly project: {
        readonly isAgenticWorkItemViewEnabled?: boolean | null;
        readonly isCreatedFromAgenticTemplate?: boolean | null;
        readonly projectType: JiraProjectType | null;
      } | null;
    } | null;
    readonly userPreferences: {
      readonly isIssueViewWivEnabled: boolean | null;
    } | null;
  } | null;
  readonly jira_projectByIdOrKey: {
    readonly isAgenticWorkItemViewEnabled?: boolean | null;
    readonly isCreatedFromAgenticTemplate?: boolean | null;
    readonly projectType: JiraProjectType | null;
  } | null;
};
export type issueViewSwitchDataFetcherQuery = {
  response: issueViewSwitchDataFetcherQuery$data;
  variables: issueViewSwitchDataFetcherQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "includeAgenticWorkItemData"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectIdOrKey"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "skipIssueByKey"
},
v5 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v6 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "idOrKey",
    "variableName": "projectIdOrKey"
  }
],
v7 = {
  "kind": "ScalarField",
  "name": "projectType"
},
v8 = {
  "condition": "includeAgenticWorkItemData",
  "kind": "Condition",
  "passingValue": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isCreatedFromAgenticTemplate"
    },
    {
      "kind": "ScalarField",
      "name": "isAgenticWorkItemViewEnabled"
    }
  ]
},
v9 = [
  (v7/*: any*/),
  (v8/*: any*/)
],
v10 = {
  "args": [
    (v5/*: any*/)
  ],
  "concreteType": "JiraUserPreferences",
  "kind": "LinkedField",
  "name": "userPreferences",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "isIssueViewWivEnabled"
    }
  ]
},
v11 = [
  (v5/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "issueKey"
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "key"
},
v13 = {
  "kind": "ScalarField",
  "name": "id"
},
v14 = [
  (v7/*: any*/),
  (v8/*: any*/),
  (v13/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueViewSwitchDataFetcherQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": (v9/*: any*/)
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "condition": "skipIssueByKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v11/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": (v9/*: any*/)
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v4/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Operation",
    "name": "issueViewSwitchDataFetcherQuery",
    "selections": [
      {
        "args": (v6/*: any*/),
        "concreteType": "JiraProject",
        "kind": "LinkedField",
        "name": "jira_projectByIdOrKey",
        "plural": false,
        "selections": (v14/*: any*/)
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "condition": "skipIssueByKey",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
              {
                "args": (v11/*: any*/),
                "concreteType": "JiraIssue",
                "kind": "LinkedField",
                "name": "issueByKey",
                "plural": false,
                "selections": [
                  (v12/*: any*/),
                  {
                    "concreteType": "JiraProject",
                    "kind": "LinkedField",
                    "name": "project",
                    "plural": false,
                    "selections": (v14/*: any*/)
                  },
                  (v13/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "785e4a57d525e0253c7efa9ebd6c8bf9033bc904c857b792c83dd3959efef986",
    "metadata": {},
    "name": "issueViewSwitchDataFetcherQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "d4e8c877cca03fe9e6778ccbe3afb93a";

export default node;
